import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-parecer-analise-documental-footer',
  standalone: true,
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParecerAnaliseDocumentalFooterComponent {
  static montarHtml(pagina: string, totalPaginas = '2'): string {
    return `
    <footer class="document-footer">
      <div class="footer-note">
        Este documento é de uso interno e confidencial do Programa Mais Médicos – AGSUS/Ministério da Saúde. É vedada a reprodução, divulgação ou utilização das informações aqui contidas sem autorização expressa. Lei nº 12.527/2011 (Lei de Acesso à Informação) · Decreto nº 7.724/2012.
      </div>
      <div class="footer-stripe"></div>
      <div class="footer-bar">
        <span>AGSUS - Programa Mais Médicos | Ministério da Saúde</span>
        <span>Emitido em ${this.obterDataEmissao()}</span>
        <strong>Pág. ${pagina}/${totalPaginas}</strong>
      </div>
    </footer>`;
  }

  private static obterDataEmissao(): string {
    const agora = new Date();
    const data = agora.toLocaleDateString('pt-BR');
    const hora = agora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    return `${data} às ${hora}`;
  }
}
